<template>
  <b-row>
    <b-col>
      <b-button
        v-if="item.prev"
        block
        class="prev"
        variant="link"
        @click="prevItem(item)"
      >
        <i class="ti ti-3x ti-arrow-left" />
      </b-button>
    </b-col>
    <b-col>
      <b-button
        v-if="item.next"
        block
        class="next"
        variant="link"
        @click="nextItem(item)"
      >
        <i class="ti ti-3x ti-arrow-right" />
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'NavigateComponent',
    props: {
      item: {
        type: Object,
        default() {
          return {};
        },
      },
      name: {
        type: String,
        default: 'item',
      },
    },
    methods: {
      nextItem(item) {
        this.$bus.$emit('t-event.navigate.success', item.next);
      },
      prevItem(item) {
        this.$bus.$emit('t-event.navigate.success', item.prev);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import 'compass/css3/transform';
  @import '~@/scss/media';

  button {
    margin-bottom: 20px;
    position: fixed;
    top: 50%;
    width: auto;

    @include transform(translateY(-50%));

    &.next {
      right: 10px;

      i {
       margin-left: 20px;
      }
    }

    &.prev {
      left: 10px;

      i {
        margin-right: 20px;
      }
    }

    &:focus {
      text-decoration: none;
    }

    i {
      color: $primary;
    }
  }

  @include editable-max-width(992px) {
    button {
      &.next {
        right: -10vw;

      }

      &.prev {
        left: -10vw;
      }
    }
  }

  @include editable-max-width(600px) {
    button {
      top: auto;
      bottom: 5px;

      &.next {
        right: 32px;

      }

      &.prev {
        left: 32px;
      }

      i {
        color: $red;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigate.vue